import { AccountUpdated } from './account/AccountController';
export const addUsersMessageId = 'add-new-users-to-list';
const blipAccountIdentity = 'blipaccountnotifications@blip.ai';
export class UserAccount {
    static $inject = ['props'];
    constructor(props) {
        this.phoneNumber = '0000000000';
        Object.assign(this, props);
    }
}
UserAccount.$inject = ['props'];
/**
 * Class representing a plan
 * @class
 */
export class Plan {
}
/**
 * Class representing a subscription
 * @class
 */
export class Subscription {
}
export class AccountService2 {
    static $inject = ['BlipService', 'BLIP_DOMAIN', 'MESSAGINGHUBDOMAIN', 'AuthenticationService', '$rootScope', 'TranslateService'];
    constructor(BlipService, BLIP_DOMAIN, MESSAGINGHUBDOMAIN, AuthenticationService, $rootScope, TranslateService) {
        'ngInject';
        this.BlipService = BlipService;
        this.BLIP_DOMAIN = BLIP_DOMAIN;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
        this.AuthenticationService = AuthenticationService;
        this.$rootScope = $rootScope;
        this.TranslateService = TranslateService;
        this.getEmailDomain = (email) => {
            const domainUrl = email.split('@')[1];
            return domainUrl.split('.')[0];
        };
        this.init();
    }
    async init() {
        this.createInitializationPromise();
        await this.refreshUser();
        this.waitForUserPromise.resolve();
    }
    createInitializationPromise() {
        this.waitForUserPromise = {
            resolve: () => undefined,
            reject: () => undefined,
            promise: new Promise(() => undefined),
        };
        const promise = new Promise((resolve, reject) => {
            this.waitForUserPromise.resolve = resolve;
            this.waitForUserPromise.reject = reject;
        });
        this.waitForUserPromise.promise = promise;
    }
    waitForInitialization() {
        return this.waitForUserPromise.promise;
    }
    async save(email) {
        let data = undefined;
        try {
            this.connect();
            const identity = encodeURIComponent(email + '@' + this.BLIP_DOMAIN);
            const accountBlip = await this.me();
            data = await this.BlipService.sendCommand({
                method: 'set',
                type: 'application/vnd.lime.account+json',
                uri: '/account',
                resource: {
                    ...accountBlip,
                    culture: accountBlip.culture,
                    identity: identity,
                    extras: {
                        ...accountBlip.extras,
                        acceptedTermsOfServiceVersion: '1.0.0',
                        acceptedPrivacyPolicyVersion: '1.0.0',
                    },
                },
            });
            await this.BlipService.sendMessage({
                type: 'text/plain',
                content: '#addlist',
                to: 'notifications@msging.net',
                id: addUsersMessageId,
            });
            await this.setUpAccount();
        }
        catch (e) {
            console.error(e);
        }
        return data;
    }
    mergeExtras(extras) {
        return this.setExtras(extras, false);
    }
    /**
     * Get account using identity name and domain
     * @param application
     * @param identity
     */
    async getAccount(identity) {
        const identitySplit = identity.split('@');
        const name = identitySplit[0];
        const domain = identitySplit[1] || this.BLIP_DOMAIN;
        return await this.BlipService.sendCommand({
            method: 'get',
            to: `postmaster@${domain}`,
            uri: `lime://${domain}/accounts/${encodeURIComponent(name)}`,
        }, 5000);
    }
    getAccountToken() {
        return this.AuthenticationService.token;
    }
    async setExtras(extras, forceUpdate = true) {
        try {
            this.connect();
            const accountBlip = await this.me();
            if (!forceUpdate) {
                extras = {
                    ...accountBlip.extras,
                    ...extras,
                };
            }
            await this.BlipService.sendCommand({
                method: 'set',
                type: 'application/vnd.lime.account+json',
                uri: '/account',
                resource: {
                    ...accountBlip,
                    extras: extras,
                },
            });
            await this.refreshUser();
        }
        catch (e) {
            console.error(e);
        }
    }
    async refreshUser() {
        try {
            await this.connect();
            this.$rootScope.applicationUser = await this.BlipService.sendCommand({
                method: 'get',
                uri: '/account',
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    /**
     * Retrieve Blip Account
     */
    async me() {
        await this.waitForInitialization();
        return this.$rootScope.applicationUser;
    }
    /**
     * This method can only be called when $rootScope.applicationUser is defined
     * Retrieve Blip Account Sync
     */
    meSync() {
        return this.$rootScope.applicationUser;
    }
    async get(identifier, domain = this.BLIP_DOMAIN) {
        this.connect();
        return await this.BlipService.sendCommand({
            method: 'get',
            to: `postmaster@${domain}`,
            uri: `lime://${domain}/accounts/${identifier}`,
        });
    }
    async setUpAccount() {
        try {
            this.connect();
            await this.BlipService.sendCommand({
                to: `postmaster@portal.${this.BLIP_DOMAIN}`,
                method: 'set',
                type: 'application/vnd.lime.account+json',
                uri: '/account',
                resource: {},
            });
            await this.refreshUser();
        }
        catch (e) {
            console.error(e);
        }
    }
    /**
     * Gets the active subscription of the account.
     * @async @public
     * @function getActiveSubscription
     * @returns {Promise<Subscription>} activeSubscription
     */
    async getActiveSubscription() {
        try {
            this.connect();
            return await this.BlipService.sendCommand({
                to: `postmaster@portal.${this.BLIP_DOMAIN}`,
                method: 'get',
                uri: '/active-subscription',
            }, 10000);
        }
        catch (e) {
            console.error(e);
        }
    }
    /**
     * Gets the plan of the account.
     * @async @public
     * @function getPlan
     * @returns {Promise<Plan>} plan
     */
    async getAccountPlan() {
        try {
            this.connect();
            const { planId } = await this.getActiveSubscription();
            return await this.getPlan(planId);
        }
        catch (e) {
            console.error(e);
        }
    }
    /**
     * Get the plan of the tenant
     * @async @public
     * @function getTenantPlan
     * @returns {Promise<Plan>} plan
     */
    async getTenantPlan(tenantId) {
        try {
            this.connect();
            const { planId } = await this.BlipService.sendCommand({
                to: `postmaster@portal.${this.BLIP_DOMAIN}`,
                method: 'get',
                uri: `/tenants/${encodeURIComponent(tenantId)}/subscription`,
            }, 10000);
            return await this.getPlan(planId);
        }
        catch (e) {
            console.error(e);
        }
    }
    async getPlan(planId) {
        try {
            this.connect();
            const { items: plans } = await this.BlipService.sendCommand({
                to: `postmaster@portal.${this.BLIP_DOMAIN}`,
                method: 'get',
                uri: `/plans?$filter=Id%20eq%20%27${planId}%27`,
            }, 10000);
            if (plans && plans.length > 0) {
                return plans[0];
            }
            return new Plan();
        }
        catch (e) {
            console.error(e);
        }
    }
    /**
     * Gets the application payment account.
     */
    async getPaymentAccount(application) {
        try {
            this.connect();
            return await this.BlipService.sendCommand({
                to: `postmaster@portal.${this.BLIP_DOMAIN}`,
                method: 'get',
                uri: `/applications/${application.applicationJson.identifier}@${this.MESSAGINGHUBDOMAIN}/payment-account`,
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    /**
     * Checks the connection with BlipService.
     * If the connection does not exist, creates a new one.
     * @async @public
     * @function connect
     */
    async connect() {
        if (!this.BlipService.isConnected()) {
            if (!this.AuthenticationService.email) {
                await this.AuthenticationService.waitForInitialization();
            }
            await this.BlipService.connect(encodeURIComponent(this.AuthenticationService.email), this.AuthenticationService.token);
        }
    }
    setUpdatedAccountListener() {
        try {
            this.BlipService.onConnect(() => {
                this.BlipService.addMessageReceiver(this.onReceiveUpdatedAccountMessage.bind(this), m => m.from.startsWith(blipAccountIdentity) && m.type === 'application/vnd.blip.account-updated+json');
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    /**
     * Sends invitation for user added to team
     * @async @public
     * @function inviteUser
     * @param user
     */
    async inviteUser(user) {
        try {
            this.connect();
            await this.BlipService.sendCommand({
                to: `postmaster@portal.${this.BLIP_DOMAIN}`,
                method: 'set',
                type: 'application/vnd.iris.portal.guest-user+json',
                uri: '/auth-permissions',
                resource: user,
            });
            await this.refreshUser();
        }
        catch (e) {
            console.error(e);
        }
    }
    /**
    * Receive a message from BlipAccount informing that the user updated his account
    * @param message - Updated account message
    */
    onReceiveUpdatedAccountMessage(message) {
        this.setUpdatedBlipAccount(message.content)
            .then((updatedAccount) => {
            this.setTranslateCurrentLanguage(updatedAccount.culture);
            updatedAccount.id = updatedAccount.email;
            this.AuthenticationService.setAccount(updatedAccount);
            this.$rootScope.$emit(AccountUpdated);
        });
    }
    async setUpdatedBlipAccount(account) {
        const accountBlip = await this.me();
        const updatedAccount = {
            ...accountBlip,
            ...account,
        };
        await this.BlipService.sendCommand({
            method: 'set',
            type: 'application/vnd.lime.account+json',
            uri: '/account',
            resource: updatedAccount,
        });
        await this.refreshUser();
        return updatedAccount;
    }
    setTranslateCurrentLanguage(culture) {
        if (culture) {
            //Update language
            let userLanguage;
            switch (culture.startsWith('pt')) {
                case true:
                    userLanguage = 'pt';
                    break;
                case false:
                    userLanguage = 'en';
                    break;
            }
            this.TranslateService.setCurrentLanguage(userLanguage);
        }
    }
    async fetchAndSetAccount() {
        try {
            let account;
            account = await this.me();
            this.AuthenticationService.setAccount(account);
        }
        catch (e) {
            console.error(e);
        }
    }
}
